import { api } from './api';

interface GetMediaUrlResponse {
  url: string;
}

export const genericApi = api.injectEndpoints({
  endpoints: builder => ({
    getMediaUrl: builder.query<GetMediaUrlResponse, string>({
      query: storage_path => ({
        url: `/generate-media-url/`,
        method: 'GET',
        params: { storage_path },
      }),
    }),
  }),
});

export const { useGetMediaUrlQuery, useLazyGetMediaUrlQuery } = genericApi;
